import React from "react";
import { Typography } from "@material-ui/core";
import { LinkRoute } from "components/LinkRoute";
import { ROOT } from "./CONSTANTS";

export const NotFound = () => {
  return (
    <>
      {/* Page Not Found! */}
      <LinkRoute to={ROOT}>Login</LinkRoute>
      <Typography variant="h5">Invalid login details</Typography>
    </>
  );
};
